<template>
  <div class="page">
    <div class="wrap">
      <div class="card">
        <div class="Title">
          {{ modalName }}
          <span v-if="desc">（{{ desc }}）</span>
        </div>
        <a-form>
          <!-- 基础信息 -->
          <div class="base-info-box">
            <div class="base-info-item">
              <a-row :gutter="64">
                <template v-for="(item, index) in configItem">
                  <a-col
                    :span="24"
                    v-if="item.blockTitle"
                    class="base-info-title-blank"
                    :class="index == 0 && 'base-info-title-no-blank'"
                  >
                    <div
                      class="base-info-title"
                      :class="index == 0 && 'base-info-title-one'"
                    >
                      {{ item.blockTitle
                      }}<span class="base-info-remind" v-if="msg && index == 0"
                        >（{{ msg }}）</span
                      >
                    </div>
                  </a-col>
                  <!-- 附件 -->
                  <template v-if="item.dataType === '7'">
                    <a-col :span="24">
                      <a-form-item
                        :required="item.isNoMust === 1"
                        :label="item.alias ? item.alias : item.itemName"
                      >
                        <div class="tip" v-if="item.template">
                          {{ item.template }}
                        </div>

                        <a-upload
                          action="/platform/files/publish/file/doupload"
                          accept="image/*"
                          list-type="picture-card"
                          :file-list="item.id"
                          :before-upload="beforeUpload"
                          @preview="handlePreview"
                          @change="selectImage($event, item)"
                        >
                          <div
                            v-if="
                              !disabledMap[item.id] &&
                              !disabled &&
                              item.id.length < maxNumber &&
                              isOpen == 1
                            "
                          >
                            <img
                              class="base-info-icon"
                              :src="addIcon"
                              width="24px"
                            />
                            <div class="ant-upload-text">点击上传图片</div>
                          </div>
                        </a-upload>
                      </a-form-item>
                    </a-col>
                  </template>
                </template>
              </a-row>
            </div>
          </div>

          <a-row :gutter="24" v-if="!disabled" style="margintop: 20px">
            <a-col :span="10" :offset="7">
              <a-button
                type="primary"
                size="large"
                @click="save"
                block
                :disabled="disabled || isOpen == 2"
                class="btn"
              >
                提交
              </a-button>
            </a-col>
          </a-row>
        </a-form>
        <a-modal
          :visible="previewVisible"
          :footer="null"
          @cancel="handleCancel"
        >
          <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getStuInfo,
  getTypeCong,
  saveStuInfo,
  getStuDetail,
  updateInfoType,
} from "@/api/form.js";
import { getFlag, saveLog } from "@/api/common";
import LoginVue from '../../user/Login.vue';
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export default {
  components: {},
  props: {
    modalName: {
      // 模块标题
      type: String,
    },
    desc: {
      // 模块描述
      type: String,
    },
    tFlag: {
      // 模块标识
      type: String,
    },
    type: {
      // 类型id
      type: [Number, String],
    },
    tjStatus: {
      // 提交状态
      type: [Number, String],
    },
    tjTip: {
      // 提交提示语
      type: String,
    },
  },
  data() {
    return {
      isOpen: "1",
      maxNumber: "",
      list: [],
      scode: localStorage.getItem("sCode"),
      previewVisible: false,
      previewImage: "",
      disabled: false,
      addIcon: require("@/assets/add-icon.png"),
      stuImgOrigin: this.$store.state.showUrl,
      uvCode: window.localStorage.getItem("uvCode"),
      configItem: [], // 采集项
      form: {},
      oldEmpInfo: {},
      filePathList: [],
      disabledMap: {},
      typeId: "",
      msg: "", // 提示信息
      tjStatusVal: "",
      tjTipVal: "",
      fileSizeText: "5M", // 文件大小上限
      sStatus: "",
      msStatus: "",
      rPlanId: "",
    };
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("请上传jpg或png格式图片!");
      }
      return isJpgOrPng;
    },
    selectImage(info, item) {
      console.log(info, item, "129829");
      if (info.file.size > 5242880) {
        this.$message.error(`请上传小于${this.fileSizeText}的图片!`);
        return;
      }
      if (info.file.status == "uploading") {
        item.id = info.fileList;
      }
      console.log(this.maxNumber, "1202389");
      if (info.file.status == "done") {
        if (this.form[item.sign]) {
          this.form[item.sign] += "," + info.file.response.result.path;
        } else {
          this.form[item.sign] = info.file.response.result.path;
        }
        item.id[item.id.length - 1].url =
          this.stuImgOrigin + info.file.response.result.path;
        this.$message.success("上传成功！");
      }
      if (info.file.status == "removed") {
        item.id = info.fileList;
        this.form[item.sign] = [];
        let arr = [];
        info.fileList.forEach((element) => {
          arr.push(element.url.substr(1));
        });
        this.form[item.sign] = arr.join(",");
      }
    },
    // 验证必填项
    getVerifTip(item) {
      let str = "";
      if (item.dataType === "7") {
        let text = item.alias ? item.alias : item.itemName;
        str = "请上传" + text;
      }
      return str;
    },
    submitVerif() {
      return new Promise((resolve, reject) => {
        let result = true;
        for (let i = 0; i < this.configItem.length; i++) {
          const item = this.configItem[i];
          if (item.isNoMust === 1) {
            if (!this.form[item.sign] || this.form[item.sign] === "") {
              this.$message.warning(this.getVerifTip(item));
              result = false;
              break;
            }
          }
        }
        resolve(result);
      });
    },
    // 提交
    save(e) {
      this.submitVerif().then((res) => {
        console.log(this.form, "98129239");
        if (!res) {
          return;
        }
        this.form.sStatus = this.tjStatusVal;
        this.form.tFlag = this.tFlag;
        this.form.planId = this.rPlanId;
        const _this = this;

        this.$confirm({
          title: "提示",
          content: `${_this.tjTipVal}`,
          onOk() {
            saveStuInfo({ ..._this.form, type: "2" })
              .then((res) => {
                if (res.code == "0") {
                  _this.$message.success(res.msg);
                  _this.queryStuInfo();

                  let userInfo = JSON.parse(localStorage.getItem("user"));
                  let sid = "";
                  if (userInfo) {
                    sid = userInfo.sid;
                  }
                  updateInfoType({sId: sid, typeId: _this.type, status: 1}).then(()=>{
                    _this.$emit("updateInfoType",3)
                  })
                } else {
                  _this.$message.error(res.msg);
                }
              })
              .catch((err) => {})
              .finally(()=>{
                // 保存操作记录
                let ids = [];
                let user = JSON.parse(localStorage.getItem("user"))
                ids.push(user.sid.toString());
                let params = { operation: "证明材料上传提交", stuIds: ids };
                saveLog(params);
              })
          },
          onCancel() {},
        });
      });
    },
    // 回显信息查询
    queryStuInfo() {
      this.oldEmpInfo = {};
      getStuInfo()
        .then((res) => {
          if (res) {
            this.oldEmpInfo = res;
            this.sStatus = res.sStatus;

            this.msStatus = res.msStatus;

            for (let key in this.form) {
              this.form[key] = res[key];
            }

            if (
              res.sStatus !== 5 &&
              res.sStatus !== 1 &&
              res.sStatus !== 2 &&
              res.sStatus !== 3
            ) {
              this.disabled = true; // 不显示按钮
            } else {
              this.disabled = false;
            }
            if (res.sStatus == 5) {
              getFlag({
                paramKey: "returnUpdate",
                uvCode: localStorage.getItem("uvCode"),
              }).then((res) => {
                this.isOpen = res.paramValue;

                let date = new Date().getTime();
                  
                if (res.paramValue == 1) {
                  if(res.opentime == "" || res.opentime == undefined || res.opentime == null){
                    this.isOpen = 1;
                  } else if (date >= res.opentime && date <= res.closetime) {
                    this.isOpen = 1
                  } else {
                    this.isOpen = 2
                  }
                } else if (res.paramValue == 2) {
                  this.disabled = false;
                }
              });
            }

            // msStatus 面试资料审核状态  1 待审核  2 通过 3退回 4 不通过
            if (this.tjStatus == 99 && !(this.sStatus == 6 || this.sStatus == 7)) {
              if (this.msStatus == 2 || this.msStatus == 4) {
                this.disabled = true;
              } else {
                this.disabled = false;
              }
            }

            this.getTypeConfig();
          }
        })
        .catch((err) => {
          console.log("err");
        });
    },
    // 获取采集项配置
    getTypeConfig() {
      this.configItem = [];
      getTypeCong({ typeId: this.typeId })
        .then((res) => {
          this.configItem = [];
          const flag = []; // 判断是否处理过
          res.forEach((item) => {
            if (item.block && flag.indexOf(item.block) === -1) {
              res.forEach((value, index) => {
                if (item.block == value.block) {
                  if (flag.indexOf(item.block) === -1) {
                    value.blockTitle = item.block;
                    flag.push(item.block);
                    if (
                      this.configItem[this.configItem.length - 1] &&
                      this.configItem[this.configItem.length - 1].blockEnd
                    ) {
                      this.configItem[
                        this.configItem.length - 1
                      ].blockEnd = false;
                    }
                  }
                  this.configItem.push(value);
                }
              });
              this.configItem[this.configItem.length - 1].blockEnd = true;
            } else if (!item.block) {
              this.configItem.push(item);
            }
          });
          res.forEach((item) => {
            // console.log("item", item);
            if (item.sign) {
              this.form[item.sign] = this.oldEmpInfo[item.sign];
              if ("true" == item.disable && this.oldEmpInfo[item.sign]) {
                this.disabledMap[item.id] = true;
              } else {
                this.disabledMap[item.id] = this.disabled;
              }
              if (item.tab == "file") {
                let oldfilelist = this.oldEmpInfo[item.sign]
                  ? this.oldEmpInfo[item.sign].split(",")
                  : [];
                let newfilelist = [];
                for (let i = 0; i < oldfilelist.length; i++) {
                  const obj = {
                    url: this.stuImgOrigin + oldfilelist[i],
                    uid: i,
                    status: "done",
                    name: `a${i}.jpg`,
                  };
                  newfilelist.push(obj);
                }
                item.id = newfilelist;
              }

              if (item.textFieldName) {
                this.form[item.textFieldName] =
                  this.oldEmpInfo[item.textFieldName];
              }
            }
          });
        })
        .catch((err) => {});
    },
    getStuDetail() {
      getStuDetail().then((res) => {
        this.rPlanId = res.vPlanId;
      });
    },
  },
  created() {
    let option = {
      type: this.type,
      desc: this.desc,
      tjStatus: this.tjStatus,
      tjTip: this.tjTip,
    };
    this.typeId = option.type;
    if (option.msg && option.msg !== "undefined") {
      this.msg = option.msg;
    }
    if (option.tjStatus && option.tjStatus !== "undefined") {
      this.tjStatusVal = option.tjStatus;
    } else {
      // this.tjStatusVal = 2;
      this.tjStatusVal = this.$route.query.tjStatus;
    }

    if (option.tjTip && option.tjTip !== "undefined") {
      this.tjTipVal = option.tjTip;
    } else {
      this.tjTipVal = "确认提交吗？提交后不可更改！";
    }
  },
  mounted() {
    this.typeId = localStorage.getItem("TypeId");
    getFlag({
      paramKey: "zmclscxzsl",
      uvCode: localStorage.getItem("uvCode"),
    }).then((res) => {
      if (
        typeof parseInt(res.paramValue) === "number" &&
        !isNaN(parseInt(res.paramValue))
      ) {
        this.maxNumber = parseInt(res.paramValue);
      } else {
        this.maxNumber = 99999;
      }
    });

    this.queryStuInfo();
    this.getStuDetail();
  },
};
</script>

<style lang="less" scoped>
.page {
  background-color: #f5f5f5;
}
.wrap {
}
.card {
  background-color: #ffffff;
  min-height: 448px;
  border-radius: 4px;
  padding: 0 20px 32px;
  .Title {
    padding: 16px 0 12px;
    border-bottom: 1px solid #f5f5f5;
    font-size: 16px;
    color: #000000;
    font-weight: 600;
    span {
      font-size: 14px;
      color: #ff4747;
      font-weight: normal;
    }
  }
}
/deep/ .ant-upload.ant-upload-select-picture-card {
  // width: 200px;
  // height: 200px;
}
.tip {
  color: #ff4747;
  font-size: 12px;
  margin-top: -12px;
}
</style>
